import {
  Activity,
  AlertTriangle,
  Bell,
  BookText,
  Building2,
  Database,
  Gauge,
  LayoutDashboard,
  LifeBuoy,
  ListChecks,
  MessageSquare,
  Package,
  Settings2,
  ShoppingBag,
  Sparkles,
  Target,
  UserCircle,
  Users,
  Wrench,
  type LucideIcon,
} from 'lucide-react';
import type { AdminPermission } from './guards';

export interface NavItem {
  label: string;
  href: string;
  icon: LucideIcon;
  permission?: AdminPermission;
  matchPrefix?: string;
}

export interface NavSection {
  label: string;
  items: NavItem[];
}

export const navigation: NavSection[] = [
  {
    label: 'Overview',
    items: [
      { label: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
    ],
  },
  {
    label: 'Notifications',
    items: [
      { label: 'Health', href: '/notifications/dashboard', icon: Activity, matchPrefix: '/notifications/dashboard' },
      { label: 'Config', href: '/notifications/config', icon: Settings2, permission: 'notifications:write' },
      { label: 'Journeys', href: '/notifications/journeys', icon: ListChecks, matchPrefix: '/notifications/journeys' },
      { label: 'User inspector', href: '/notifications/users', icon: Users, matchPrefix: '/notifications/users' },
      { label: 'Alert firings', href: '/notifications/alerts/firings', icon: Bell, matchPrefix: '/notifications/alerts/firings' },
      { label: 'Alert policies', href: '/notifications/alerts/policies', icon: ListChecks, matchPrefix: '/notifications/alerts/policies' },
      { label: 'Audit', href: '/notifications/audit', icon: BookText },
    ],
  },
  {
    label: 'Operations',
    items: [
      { label: 'Users', href: '/users', icon: Users, permission: 'users:write' },
      { label: 'Teams', href: '/teams', icon: Building2, permission: 'teams:write', matchPrefix: '/teams' },
      { label: 'Matching queue', href: '/teams/queue', icon: Building2, matchPrefix: '/teams/queue' },
      { label: 'Support', href: '/support', icon: LifeBuoy },
      { label: 'Communication', href: '/communication', icon: MessageSquare },
    ],
  },
  {
    label: 'AI funnel',
    items: [
      { label: 'AI ops', href: '/ai', icon: Sparkles },
      { label: 'Coverage gaps', href: '/ai/coverage-gaps', icon: AlertTriangle, matchPrefix: '/ai/coverage-gaps' },
      { label: 'Approach outcomes', href: '/ai/outcomes', icon: Target, matchPrefix: '/ai/outcomes' },
      { label: 'Portfolio state', href: '/ai/portfolio-state', icon: Gauge, matchPrefix: '/ai/portfolio-state' },
      { label: 'User models', href: '/ai/user-models', icon: UserCircle, matchPrefix: '/ai/user-models' },
    ],
  },
  {
    label: 'Content',
    items: [
      { label: 'Taxonomy', href: '/taxonomy', icon: Package },
      { label: 'Store', href: '/store', icon: ShoppingBag },
    ],
  },
  {
    label: 'Platform',
    items: [
      { label: 'Analytics', href: '/analytics', icon: Activity },
      { label: 'System', href: '/system', icon: Database },
      { label: 'Migrations', href: '/migrations', icon: Wrench, permission: 'migrations:run' },
    ],
  },
];
